import type { ReactNode } from "react";

export function QuotesModifyLink(props: {
  children: ReactNode;
  "data-testid"?: string | undefined;
}) {
  return (
    <div
      className="text-[14px] font-light text-content-muted"
      data-testid={props["data-testid"]}
    >
      {props.children}
    </div>
  );
}
